import { Recruiter } from "@/model/recruiters";

export interface ProjectsFilter {
  readonly search?: string;
  readonly customer_id?: string;
  readonly status?: string;
  readonly legal_entity_id?: string;
  readonly responsible_id?: string;
  readonly created_at_from?: string;
  readonly created_at_to?: string;
}

export const defaultProjectsFilterFields: ProjectsFilter = {
  search: "",
  customer_id: undefined,
  status: "",
  legal_entity_id: undefined,
  responsible_id: undefined,
  created_at_from: "",
  created_at_to: "",
} as const;

export interface ProjectsPopupLists {
  readonly customerOptions: readonly { value: string; label: string }[];
  readonly projectStatusOptions: readonly { value: string; label: string }[];
  readonly legalEntityOptions: readonly { value: string; label: string }[];
  readonly recruiters: readonly Recruiter[];
}
